import posthog from "posthog-js";

const POSTHOG_KEY = (import.meta.env.VITE_POSTHOG_KEY as string | undefined)?.trim();
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined)?.trim() ||
  "https://us.i.posthog.com";

let initialized = false;

export function initAnalytics(): void {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (!POSTHOG_KEY) return;
  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      autocapture: false,
      persistence: "localStorage+cookie",
      person_profiles: "identified_only",
    });
    initialized = true;
  } catch {
    /* ignore */
  }
}

export function isAnalyticsEnabled(): boolean {
  return initialized;
}

export function trackEvent(
  event: string,
  properties?: Record<string, unknown>,
): void {
  if (!initialized) return;
  try {
    posthog.capture(event, properties);
  } catch {
    /* ignore */
  }
}
